export const findAPI = (win: Window): { version: '1.2' | '2004'; api: unknown } | false => {
  const limit = 500
  const visited = new WeakSet<Window>()
  const queue: Window[] = [win]

  let attempts = 0
  while (queue.length > 0 && attempts < limit) {
    const currentWin = queue.shift()!
    attempts += 1

    if (visited.has(currentWin)) {
      continue
    }
    visited.add(currentWin)

    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((currentWin as any).API_1484_11) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return { version: '2004', api: (currentWin as any).API_1484_11 }
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((currentWin as any).API) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return { version: '1.2', api: (currentWin as any).API }
      }

      if (
        currentWin.parent &&
        currentWin.parent !== currentWin &&
        !visited.has(currentWin.parent)
      ) {
        queue.push(currentWin.parent)
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const opener = (currentWin as any).opener as Window | null
      if (opener && !visited.has(opener)) {
        queue.push(opener)
      }
    } catch {
      // Cross-domain access error - skip this window
    }
  }

  return false
}
